import { api, unwrapData } from 'app/store/api';
import {
    TransactionAnalytics,
    TransactionAnalyticsPeriod,
} from '../types/transaction-analytics.types';

export type TransactionAnalyticsQueryArgs = {
    gatewayId: number;
    period: TransactionAnalyticsPeriod;
    startDate?: string;
    endDate?: string;
};

export const transactionAnalyticsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        transactionAnalytics: builder.query<
            TransactionAnalytics,
            TransactionAnalyticsQueryArgs
        >({
            transformResponse: unwrapData,
            query: ({ gatewayId, period, startDate, endDate }) => ({
                url: `workspaces/${gatewayId}/transactions/analytics`,
                method: 'GET',
                params:
                    period === 'custom' && startDate && endDate
                        ? { start_date: startDate, end_date: endDate }
                        : { period },
            }),
            providesTags: ['Transaction'],
        }),
    }),
});

export const { useTransactionAnalyticsQuery } = transactionAnalyticsApi;
